/**
 * Tiny numeric helpers shared by the indicator library (and the scanner,
 * which re-exports them). Kept dependency-free so they run in the browser
 * (chart) and Node (scanner worker) identically.
 */

/** Index-aligned EMA series (out[i] is the EMA through value i, seeded with
 *  the first value). Unlike `technicalindicators` EMA.calculate (which trims
 *  the warmup), this stays 1:1 with the input so it can be used per-bar. */
export function emaSeries(values: number[], period: number): number[] {
  if (values.length === 0) return [];
  const k = 2 / (period + 1);
  const out: number[] = [values[0]!];
  for (let i = 1; i < values.length; i++) {
    out.push(values[i]! * k + out[i - 1]! * (1 - k));
  }
  return out;
}

/** Last finite element of a numeric series, or null. Used to turn an
 *  index-aligned indicator series into a single scalar (scanner / watchlist
 *  cell value). */
export function lastFinite(values: ReadonlyArray<number | null> | undefined): number | null {
  if (!values || values.length === 0) return null;
  const v = values[values.length - 1];
  return typeof v === "number" && Number.isFinite(v) ? v : null;
}
